module.exports = __webpack_public_path__ + "img/add_shopping_cart.4320b77c.svg";